import { decodeString } from "@findemdev/findem-helpers";
import { Tooltip } from "@findemdev/maui";
import type { IGetCompanyLogosResponseDataObj } from "../../../../types/pub";
import { CellText, CompanyCell } from "../../RaasClientPortal.styled";
import { getLogoRef } from "../../utils";
import { CompanyLogo } from "./CompanyLogo";

interface ICompanyCellContentProps {
  companyDetailsByMetaRef: Record<
    string,
    IGetCompanyLogosResponseDataObj | undefined
  >;
  label: string;
  metaRef?: string;
}

export const CompanyCellContent = ({
  companyDetailsByMetaRef,
  label,
  metaRef,
}: ICompanyCellContentProps) => {
  if (label === "-") {
    return <CellText $muted>—</CellText>;
  }

  const companyDetails = metaRef ? companyDetailsByMetaRef[metaRef] : undefined;
  const displayLabel = decodeString(
    companyDetails?.company?.company_name || label,
  );
  const logoRef = getLogoRef({ companyDetails });

  return (
    <CompanyCell>
      <CompanyLogo label={displayLabel} logoRef={logoRef} />
      <Tooltip title={displayLabel}>
        <CellText $link>{displayLabel}</CellText>
      </Tooltip>
    </CompanyCell>
  );
};
